<template>
  <div class="doing-pick" v-loading="loading">
    <div class="anCore-pageToolBar">
      <a href="javascript:;" style="margin-right:25px;" @click.prevent="goHistory">历史记录查询</a>
      <a href="javascript:;" style="margin-right:25px;" @click.prevent="goWorkload">采样人员工作量统计</a>
      <a href="javascript:;" style="margin-right:25px;" @click.prevent="goLabel">现场标签</a>
      <div style="position:absolute;top:10px;right:55px;">
        <a
          class="btn btn-default btn-sm"
          :class="{ active: showOverview }"
          style="padding-right:30px;"
          title="点此显示任务概况"
          href="javascript:;"
          @click.prevent="toggleOverview"
        >
          <i class="fa fa-bar-chart" /> 概况
        </a>
      </div>
    </div>

    <div class="row" style="margin:0;height:calc(100% - 40px);">
      <div class="col-md-4 doing-pick__left">
        <IvanGroupProjectList
          :groups="groups"
          :current-xmbh="current && current.xmbh"
          @select="selectProject"
        />
      </div>
      <div class="col-md-8 doing-pick__right">
        <div v-show="showOverview" class="doing-pick__overview">
          <div class="ivan-stat-card">
            <div class="ivan-stat-card__inner">
              <div class="pull-left text-center" style="width:19%;font-size:18px;padding:5px 0;" title="进行中任务统计">
                <i class="fa fa-clock-o" style="margin-right:10px;color:#1AAEDA;" />
                <span style="color:#44B2d6;">进行中</span>
              </div>
              <div class="pull-left" style="width:33%;border-left:5px solid #e9f0f5;" title="监测任务数量">
                <div style="font-size:18px;font-weight:bold;">{{ projectTaskCount }}</div>
                <div class="text-muted">监测任务</div>
              </div>
              <div class="pull-left" style="width:33%;" title="采样任务数量">
                <div style="font-size:18px;font-weight:bold;">{{ pickTaskCount }}</div>
                <div class="text-muted">采样任务</div>
              </div>
            </div>
          </div>

          <div class="ivan-chart-card">
            <div class="ivan-chart-card__title">进行中任务各类型样品占比</div>
            <div ref="typeChart" style="height:280px;" />
          </div>

          <div class="ivan-chart-card">
            <div class="ivan-chart-card__title">进行中任务采样人员工作量统计</div>
            <div ref="staffChart" style="height:280px;" />
          </div>
        </div>

        <PickTaskEmbedPanel
          v-if="!showOverview && current"
          :project="current"
          :rows="current.pickRows || []"
          :readonly="true"
          @open-project="openProject"
          @need-refresh="softReload"
        />
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import IvanGroupProjectList from '@/components/ivan/IvanGroupProjectList.vue'
import PickTaskEmbedPanel from '@/components/ivan/PickTaskEmbedPanel.vue'
import { fetchDoingPickBundle } from '@/utils/pickAdminAdapter'
import { collectSelectedPickIds, restorePickRowSelection, applyOverridesToRows } from '@/utils/pickAdapter'

export default {
  name: 'DoingPick',
  components: { IvanGroupProjectList, PickTaskEmbedPanel },
  data() {
    return {
      loading: false,
      groups: [],
      current: null,
      showOverview: true,
      projectTaskCount: 0,
      pickTaskCount: 0,
      typeShare: [],
      staffWorkload: [],
      typeChart: null,
      staffChart: null
    }
  },
  mounted() {
    this.load()
    window.addEventListener('resize', this.resizeCharts)
  },
  activated() {
    this.softReload()
  },
  deactivated() {},
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeCharts)
    if (this.typeChart) this.typeChart.dispose()
    if (this.staffChart) this.staffChart.dispose()
  },
  methods: {
    async softReload() {
      try {
        const prevSelected = collectSelectedPickIds(this.current && this.current.pickRows)
        const bundle = await fetchDoingPickBundle()
        this.groups = bundle.groups
        this.projectTaskCount = bundle.projectTaskCount
        this.pickTaskCount = bundle.pickTaskCount
        this.typeShare = bundle.typeShare
        this.staffWorkload = bundle.staffWorkload
        if (this.current && this.current.xmbh) {
          const hit = (bundle.projectViews || []).find(p => p.xmbh === this.current.xmbh)
          if (hit) {
            applyOverridesToRows(hit.pickRows)
            restorePickRowSelection(hit.pickRows, prevSelected)
            this.current = hit
          }
        }
        if (this.showOverview) this.$nextTick(() => this.renderCharts())
      } catch (e) { /* 静默，避免打断审核操作 */ }
    },
    async load() {
      this.loading = true
      try {
        const bundle = await fetchDoingPickBundle()
        this.groups = bundle.groups
        this.projectTaskCount = bundle.projectTaskCount
        this.pickTaskCount = bundle.pickTaskCount
        this.typeShare = bundle.typeShare
        this.staffWorkload = bundle.staffWorkload
        this.$nextTick(() => this.renderCharts())
      } catch (e) {
        this.$message.error('加载采样管理失败')
      } finally {
        this.loading = false
      }
    },
    renderCharts() {
      if (!this.$refs.typeChart || !this.$refs.staffChart) return
      if (!this.typeChart) this.typeChart = echarts.init(this.$refs.typeChart)
      if (!this.staffChart) this.staffChart = echarts.init(this.$refs.staffChart)

      this.typeChart.setOption({
        title: { text: '样品类型占比', left: 'center', top: 'center', textStyle: { fontSize: 14, color: '#666' } },
        tooltip: { trigger: 'item', formatter: '{b}: {d}%' },
        series: [{
          type: 'pie',
          radius: ['42%', '68%'],
          data: this.typeShare.map(t => ({ name: t.name, value: t.value })),
          label: { formatter: '{b}: {d}%' }
        }]
      })

      const names = this.staffWorkload.map(s => s.name)
      this.staffChart.setOption({
        tooltip: { trigger: 'axis' },
        legend: { data: ['采样次', '样品量'] },
        grid: { left: 50, right: 20, top: 40, bottom: 40 },
        xAxis: { type: 'category', data: names },
        yAxis: { type: 'value' },
        series: [
          { name: '采样次', type: 'bar', data: this.staffWorkload.map(s => s.pickCount), itemStyle: { color: '#1AAEDA' } },
          { name: '样品量', type: 'bar', data: this.staffWorkload.map(s => s.sampleCount), itemStyle: { color: '#75ce66' } }
        ]
      })
    },
    resizeCharts() {
      if (this.typeChart) this.typeChart.resize()
      if (this.staffChart) this.staffChart.resize()
    },
    toggleOverview() {
      this.showOverview = true
      this.current = null
      this.$nextTick(() => this.renderCharts())
    },
    selectProject(p) {
      this.current = p
      this.showOverview = false
    },
    openProject(p) {
      if (p && p.xmbh) this.$router.push({ path: '/task-track', query: { xmbh: p.xmbh } })
    },
    goHistory() {
      this.$router.push('/stub/pick-history')
    },
    goWorkload() {
      this.$message.info('采样人员工作量统计页开发中')
    },
    goLabel() {
      this.$router.push('/soil/handover')
    }
  }
}
</script>

<style scoped>
.doing-pick {
  height: 100%;
  position: relative;
  background: #fff;
}
.anCore-pageToolBar {
  position: relative;
  height: 40px;
  line-height: 40px;
  padding: 0 12px;
  border-bottom: 1px solid #e8e8e8;
  background: #fff;
}
.doing-pick__left {
  height: 100%;
  overflow: auto;
  padding: 0;
  background: #fff;
}
.doing-pick__right {
  height: 100%;
  overflow: auto;
  background-color: #e9f0f5;
  padding: 5px;
}
.ivan-stat-card {
  height: 80px;
  margin: 10px;
  background: white;
  border-radius: 0.25em;
  box-shadow: rgb(215, 228, 237) 0 3px 0;
}
.ivan-stat-card__inner {
  height: 80px;
  width: 100%;
  padding-top: 20px;
  text-align: center;
}
.ivan-chart-card {
  margin: 10px;
  background: white;
  border-radius: 0.25em;
  padding: 1em;
  box-shadow: rgb(215, 228, 237) 0 3px 0;
}
.ivan-chart-card__title {
  border-left: 3px #1AAEDA solid;
  font-size: 16px;
  font-weight: bold;
  padding-left: 10px;
  margin-bottom: 8px;
}
</style>
